import React, { useRef } from "react";
import * as S from "./BrandPrinciplesHero.styles";
import { IHeroSection } from "./BrandPrinciplesHero.types";
import { absoluteAssetUrl, getOptimizedImageUrl } from "util/assets";
import { useVideoCleanup } from "hooks/useDestroyVideoRef";
import { usePlayVideoInView } from "hooks/usePlayInView";

export const BrandPrinciplesHeroVideo = ({
  section,
  isInView,
  activeTab,
  onVideoEnded,
  onLoadedMetadata,
}: Readonly<{
  section: IHeroSection;
  activeTab: IHeroSection;
  isInView?: boolean;
  onVideoEnded: () => void;
  onLoadedMetadata: (e: React.SyntheticEvent<HTMLVideoElement>) => void;
}>) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useVideoCleanup(videoRef);
  usePlayVideoInView(videoRef, isInView && activeTab.id === section.id, true);

  return (
    <S.BackgroundVideo
      id="activeVideo"
      ref={videoRef}
      src={section?.src}
      $isActive={activeTab.id === section.id}
      poster={getOptimizedImageUrl(absoluteAssetUrl(section?.poster), 1920 * 2)}
      muted
      playsInline
      autoPlay={isInView && activeTab.id === section.id}
      preload="auto"
      width="1920"
      height="880"
      onLoadedMetadata={onLoadedMetadata}
      onEnded={onVideoEnded}
    />
  );
};
